import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import {NavLink} from 'react-router-dom';
import autobind from 'autobind-decorator';

@connect(
    state => ({
        errors: state.apa.errors,
        isSuperUser: state.apa.isSuperUser,
        isAuthenticated: state.apa.isAuthenticated
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Login extends Component {

    state = {
        username: '',
        password: '',
        showPassword: true,
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        const {
            username,
            password
        } = this.state;
        this.props.login(username, password)
    }


    render() {
        if (this.props.isAuthenticated) {
            if(this.props.isSuperUser) {
                return <Redirect to="/customer" />
            } else {
                return <Redirect to="/training/welcome" />
            }
        }
        const { errors } = this.props
        const { non_field_errors } = errors;
        return (
            <form className="form-signin" onSubmit={this.onSubmit}>
                <h1>Login</h1>
                {non_field_errors && non_field_errors.map(
                    (error, index) => <p key={`error_${index}`} className='text-danger'>{error}</p>
                )}
                <div className="form-group">
                    <label htmlFor="email">
                        <FormattedMessage id="app.login.username" defaultMessage="Zugangscode" />
                    </label>
                    <input id="username" className="form-control" type="text" onChange={
                        e => this.setState({ username: e.target.value })
                    } required={true} autoFocus={true} />
                </div>
                <div className="form-group">
                    <label htmlFor="password">
                        <FormattedMessage id="app.login.password" defaultMessage="Passwort" />
                    </label>
                    <div style={{display: "flex", flexDirection:"row"}}>
                    <input id="password" className="form-control" type={this.state.showPassword ? ("password"):("text")} onChange={
                        e => this.setState({ password: e.target.value })
                    } required={true} />
                    <span style={{marginLeft:270, marginTop: 5, position: "absolute"}} onClick={()=>this.setState({ showPassword: !this.state.showPassword })}>
                        {this.state.showPassword ?
                            (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16"> <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/> <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/> </svg>)
                            :
                            (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-slash-fill" viewBox="0 0 16 16"> <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/> <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/> </svg>)
                        }
                    </span>
                    </div>
                </div>
                <button type="submit" className="btn btn-block btn-primary">
                    <FormattedMessage id="app.login.login_btn" defaultMessage="Login" />
                </button>
                <br />
                <NavLink to="/forgotpassword" className="nav-link">
                    Passwort vergessen
                </NavLink>
            </form>
        )
    }
}

Login.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
